export const tableOption = {
    page:false,
    border: true,
    stripe: true,
    align:'center',
    menuAlign:'center',
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [{
      label: '排行榜名称',
      prop: 'rankingTitle',
      overHidden: true,
      align: 'left',
      width: 240
    }, {
      label: '规则',
      prop: 'rankingType',
      overHidden: true,
      align: 'left',
      width: 120
    }, {
      label: '参与范围',
      prop: 'rankingTarget',
      overHidden: true,
      align: 'left',
      width: 100
    }, {
      label: '周期',
      prop: 'rankingPeriod',
      overHidden: true,
      align: 'left',
      width: 100
    }, {
      label: '时间范围',
      prop: 'rankingDateInterval',
      overHidden: true,
      align: 'left',
      width: 220
    }]
  }

export const rankingDetailForMemberTableOption = {
    about: 'member',  // 标志位
    header: false,
    page:false,
    border: true,
    stripe: true,
    align:'center',
    menu:false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    columnBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [{
      label: '排名',
      prop: 'ranking',
      sortable: true,
      overHidden: true,
      align: 'center',
      solt: true,
      fixed: true,
      width: 100
    }, {
      label: '员工Full Name',
      prop: 'nickname',
      overHidden: true,
      align: 'left',
      solt: true,
      width: 160
    }, {
      label: '员工姓名',
      prop: 'realname',
      overHidden: true,
      align: 'left',
      width: 130
    }, {
      label: '员工编号',
      prop: 'unionId',
      overHidden: true,
      align: 'left',
      width: 150
    }, {
      label: '数值',
      prop: 'rankingValue',
      overHidden: true,
      align: 'left',
      width: 120
    }, {
      label: '备注',
      prop: 'rankingExtraInfo',
      overHidden: true,
      align: 'left'
    }]
  }

export const rankingDetailForPostTableOption = {
    about: 'post', // 标志位
    header: false,
    page:false,
    border: true,
    stripe: true,
    align:'center',
    menu:false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    columnBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [{
      label: '排名',
      prop: 'ranking',
      sortable: true,
      overHidden: true,
      align: 'center',
      solt: true,
      fixed: true,
      width: 100
    }, {
      label: '帖子内容预览',
      prop: 'postTitle',
      overHidden: true,
      align: 'left',
      solt: true,
      width: 210
    }, {
      label: '发帖人Full Name',
      prop: 'nickname',
      overHidden: true,
      align: 'left',
      solt: true,
      width: 120
    }, {
      label: '发帖人姓名',
      prop: 'realname',
      overHidden: true,
      align: 'left',
      width: 120
    }, {
      label: '发帖人员工编号',
      prop: 'unionId',
      overHidden: true,
      align: 'left',
      width: 120
    }, {
      label: '数值',
      prop: 'rankingValue',
      overHidden: true,
      align: 'left',
      width: 120
    }, {
      label: '备注',
      prop: 'rankingExtraInfo',
      overHidden: true,
      align: 'left'
    }]
  }

export const rankingTypes = [
  { label: '帖子数量', value: 1 },
  { label: '评论数量', value: 2 },
  { label: '积分', value: 3 },
  { label: '活跃值', value: 4 },
  { label: '被点赞数量', value: 5 },
  { label: '被收藏数量', value: 6 },
  { label: '粉丝数量', value: 7 },
  { label: '被打赏积分数', value: 8 }
]

export const rankingTargetTypes = [
  { label: '员工', value: 1, tableOption: rankingDetailForMemberTableOption },
  { label: '帖子', value: 3, tableOption: rankingDetailForPostTableOption },
  { label: '部门', value: 2, tableOption: rankingDetailForMemberTableOption }
]

export const rankingPeroidTypes = [
  { label: '每天', value: 1 },
  { label: '每周', value: 2 },
  { label: '每月', value: 3 },
  { label: '每年', value: 4 },
  { label: '至今', value: 5 },
  { label: '昨日', value: 6 }
]